export default {
    rightReveal:{
        delay    : 200,
        distance : '90px',
        origin   : 'right',
        duration : 1000,
        easing   : 'ease-in-out',
        scale    : 1,
        reset    : false 
    },
    leftReveal:{
        delay    : 200,
        distance : '90px',
        origin   : 'left',
        duration : 1000,
        easing   : 'ease-in-out',
        scale    : 1,
        reset    : false,
        // //当动画开始之前会被触发
        // beforeReveal: function(domEl){
        //     console.log('动画执行了',domEl)
        // },
        // //鼠标滚轮滚动之前会被触发
        // beforeReset: function(domEl){
        //     console.log('滚轮开始---',domEl)
        // },
        // //动画开始之后会被触发
        // afterReveal: function(domEl){
        //     console.log('动画结束了',domEl)
        // },
        // //滚轮滚动之后会被触发
        // afterReset: function(domEl){
        //     console.log('滚轮结束了',domEl)
        // }
    },
    fadeReveal:{
        delay    : 200,
        distance : '0px',
        origin   : 'right',
        easing   : 'ease-in-out',
        scale    : 0,
        reset    : false,
        // //当动画开始之前会被触发
        // beforeReveal: function(domEl){
        //     console.log('动画执行了',domEl)
        // },
        // //鼠标滚轮滚动之前会被触发
        // beforeReset: function(domEl){
        //     console.log('滚轮开始---',domEl)
        // },
        // //动画开始之后会被触发
        // afterReveal: function(domEl){
        //     console.log('动画结束了',domEl)
        // },
        // //滚轮滚动之后会被触发
        // afterReset: function(domEl){
        //     console.log('滚轮结束了',domEl)
        // }
    },
    fooReveal:{
        delay    : 200,
        distance : '90px',
        origin   : 'bottom',
        duration : 1000,
        easing   : 'ease-in-out',
        scale    : 1,
        reset    : false,
        //  //当动画开始之前会被触发
        // beforeReveal: function(domEl){
        //     console.log('动画执行了',domEl)
        // },
        // //鼠标滚轮滚动之前会被触发
        // beforeReset: function(domEl){
        //     console.log('滚轮开始---',domEl)
        // },
        // //动画开始之后会被触发
        // afterReveal: function(domEl){
        //     console.log('动画结束了',domEl)
        // },
        // //滚轮滚动之后会被触发
        // afterReset: function(domEl){
        //     console.log('滚轮结束了',domEl)
        // }
    },
    topReveal:{
        delay    : 200,
        distance : '90px',
        origin   : 'top',
        duration : 1000,
        easing   : 'ease-in-out',
        scale    : 1,
        reset    : false,
        // //当动画开始之前会被触发
        // beforeReveal: function(domEl){
        //     console.log('动画执行了',domEl)
        // },
        // //鼠标滚轮滚动之前会被触发
        // beforeReset: function(domEl){
        //     console.log('滚轮开始---',domEl)
        // },
        // //动画开始之后会被触发
        // afterReveal: function(domEl){
        //     console.log('动画结束了',domEl)
        // },
        // //滚轮滚动之后会被触发
        // afterReset: function(domEl){
        //     console.log('滚轮结束了',domEl)
        // }
    },
}



// WEBPACK FOOTER //
// ./src/plugins/scrollReveal/index.js